/**
 * Shared Tailwind class strings for the filter popovers (Select, SingleSelect,
 * Range, DateRange, DateRangeWithPresets, Zipcode).
 *
 * The mobile-cap classes (FIR-7449) keep the popover within a short viewport so
 * the pinned Reset / Cancel / Apply footer stays on-screen and tappable:
 *   - `max-w-[calc(100vw-1.5rem)]` caps width to the viewport minus the 12px
 *     `collisionPadding` gutter on each side.
 *   - `max-h-[var(--radix-popper-available-height)]` caps height to the space
 *     Radix reports as available.
 *   - `flex flex-col` lets the scrollable body (`min-h-0 overflow-y-auto`) and
 *     the `flex-shrink-0` footer split that capped height.
 * Pair this with `collisionPadding={12}` on the `DropdownMenuContent`.
 */
export const FILTER_POPOVER_MOBILE_CAP =
  'max-w-[calc(100vw-1.5rem)] max-h-[var(--radix-popper-available-height)] flex flex-col'

/** Footer row: never shrinks, so it stays pinned below the scrollable body. */
export const FILTER_POPOVER_FOOTER = 'flex flex-shrink-0'

/**
 * Scrollable body region between header and footer.
 *
 * `overflow-y-auto` makes the browser compute `overflow-x` to `auto` as well
 * (per spec, a non-visible value on one axis forces the other off `visible`),
 * so this element clips on BOTH axes. Inputs sit flush against its edges, and
 * their 4px focus ring (`shadow-[0_0_0_4px_…]`) was getting sliced off where it
 * met the clip boundary. The `-m-1 p-1` pair fixes this without moving any
 * content: the negative margin expands the clip box 4px outward on every side
 * (eating into the popover's 12px `p-3`), and the equal padding insets the
 * content back to exactly where it was — so the ring now lands inside the
 * padding and renders in full.
 */
export const FILTER_POPOVER_BODY = 'min-h-0 overflow-y-auto -m-1 p-1'

/**
 * Base chrome shared by the single-column filter popovers. The mobile cap is
 * appended so all callers stay consistent; per-component width tweaks (e.g.
 * `lg:w-[260px]`) are passed alongside it via `cn`.
 */
export const FILTER_POPOVER_CONTENT_BASE =
  '!rounded-xl !border-neutral-200 !shadow-lg !bg-white !p-3 ' +
  FILTER_POPOVER_MOBILE_CAP
